document.addEventListener('DOMContentLoaded',function() {

    const el = document.getElementById('offers');

    let getJSON = function(url, callback) {
        let xhr = new XMLHttpRequest();
        xhr.open('GET', url, true);
        xhr.responseType = 'json';
        xhr.onload = function() {
            let status = xhr.status;
            if (status === 200) {
                callback(null, xhr.response);
            } else {
                callback(status, xhr.response);
            }
        };
        xhr.send();
    };


    const init = function() {
        
        const btn = el.getElementsByClassName('js-showAllOffers')[0],
              items = el.getElementsByClassName('js-item'),
              more = el.getElementsByClassName('js-more')[0];
              
        const hideItems = function() {
            for (let i = 5; i < items.length; i++) {
                items[i].classList.add('is-hidden');
            }
            btn.classList.remove('minus');
        }
        
        const showItems = function() {
            for (let i = 0; i < items.length; i++) {
                items[i].classList.remove('is-hidden');
            }
            btn.classList.add('minus');
        }


        if (items.length > 5) {
            hideItems();
            more.classList.remove('is-hidden');
        }

        btn.addEventListener('click', function(e) {
            
            if (btn.classList.contains('minus')) {
                
                hideItems();

                

            } else {
                showItems();
                
            }

           // e.preventDefault() ? e.preventDefault() : e.preventDefault = false;
        })
    };

    if (el) {
        getJSON('https://api.zawodagronom.pl/api/list/nd74m-d62ndf-42s04-23d0obp',
          function (err, data) {
              if (err === null) {
                  let html = '';
                  data.forEach(function(item) {
                      html += '<tr class="js-item">'+
                          '<td><div>' + item.title + '</div></td>' +
                          '<td><div><i class="icon-pin"></i>' + (item.location ? item.location : item.countryRegionName) + '</div></td>' +
                          '<td><div>' + (item.publishDate ? item.publishDate : false) + '</div></td>' +
                          '<td><div><a href="' + item.urlWithLayout + '" class="o-btn o-btn--yellow">Aplikuj</a></div></td>' +
                          '</tr>'
                  });

                  document.getElementById('c-offers__list').innerHTML = html;
                  // console.log(data);
                  init();
              }
          });
    }
    //el ? init() : false;

}, false)
